export default "__VITE_ASSET__BZKUsL86__"